
import React, {Component} from "react";
import { withWhiteLabelContext } from "react-whitelabel";

class HomePlayBulletSection extends Component {
    render() {
        const {label} =this.props;
        const {bullets} = label.homePlayBulletSection;
        return (
            <div className='home_play_bullet_section'>
                <div className='home_play_section_title'>The Power of Home Play</div>
                <div className='home_play_bullet'><i className='fa fa-trophy home_play_bullet_icon yellow'></i><span className='home_play_bullet_text'>{bullets[0]}</span></div>
                <div className='home_play_bullet'><i className='fa fa-home home_play_bullet_icon red'></i><span className='home_play_bullet_text'>{bullets[1]}</span></div>
                <div className='home_play_bullet'><i className='fa fa-gamepad home_play_bullet_icon blue'></i><span className='home_play_bullet_text'>{bullets[2]}</span></div>
            </div>
        );
    }
}

export default withWhiteLabelContext(HomePlayBulletSection);


// WEBPACK FOOTER //
// ./src/components/containers/home-play/home-play-bullet-section.js